export const calculateAngle = (pointA, pointB, pointC) => {
  const radians = Math.atan2(
    pointC.y - pointB.y,
    pointC.x - pointB.x
  ) - Math.atan2(
    pointA.y - pointB.y,
    pointA.x - pointB.x
  );

  let angle = Math.abs(radians * 180.0 / Math.PI);
  
  if (angle > 180.0) {
    angle = 360 - angle;
  }

  return angle;
};

export const getLandmark = (landmarks, index) => {
  if (!landmarks || !landmarks[index]) return null;
  const landmark = landmarks[index];
  return {
    x: landmark.x,
    y: landmark.y,
    z: landmark.z || 0,
    visibility: landmark.visibility || 0
  };
};

export const isLandmarkVisible = (landmark, threshold = 0.5) => {
  return landmark && landmark.visibility > threshold;
};

export const detectPunch = (landmarks) => {
  const leftShoulder = getLandmark(landmarks, 11);
  const leftElbow = getLandmark(landmarks, 13);
  const leftWrist = getLandmark(landmarks, 15);
  const rightShoulder = getLandmark(landmarks, 12);
  const rightElbow = getLandmark(landmarks, 14);
  const rightWrist = getLandmark(landmarks, 16);

  if (!leftWrist || !rightWrist) return { detected: false };

  const leftExtended = leftWrist.x < leftShoulder.x - 0.15;
  const rightExtended = rightWrist.x > rightShoulder.x + 0.15;

  const leftPunch = leftExtended && isLandmarkVisible(leftWrist);
  const rightPunch = rightExtended && isLandmarkVisible(rightWrist);

  return {
    detected: leftPunch || rightPunch,
    side: leftPunch ? 'left' : rightPunch ? 'right' : null,
    power: Math.abs(leftWrist.x - leftShoulder.x) + Math.abs(rightWrist.x - rightShoulder.x)
  };
};

export const detectJump = (landmarks, previousLandmarks) => {
  if (!previousLandmarks) return { detected: false };

  const leftHip = getLandmark(landmarks, 23);
  const rightHip = getLandmark(landmarks, 24);
  const prevLeftHip = getLandmark(previousLandmarks, 23);
  const prevRightHip = getLandmark(previousLandmarks, 24);

  if (!leftHip || !rightHip || !prevLeftHip || !prevRightHip) return { detected: false };

  const currentHipY = (leftHip.y + rightHip.y) / 2;
  const prevHipY = (prevLeftHip.y + prevRightHip.y) / 2;
  const verticalMovement = prevHipY - currentHipY;

  return {
    detected: verticalMovement > 0.08,
    height: verticalMovement
  };
};

export const detectWave = (landmarks, previousLandmarks) => {
  if (!previousLandmarks) return { detected: false };

  const leftWrist = getLandmark(landmarks, 15);
  const rightWrist = getLandmark(landmarks, 16);
  const prevLeftWrist = getLandmark(previousLandmarks, 15);
  const prevRightWrist = getLandmark(previousLandmarks, 16);

  if (!leftWrist || !rightWrist || !prevLeftWrist || !prevRightWrist) return { detected: false };

  const leftMovement = Math.abs(leftWrist.x - prevLeftWrist.x);
  const rightMovement = Math.abs(rightWrist.x - prevRightWrist.x);

  const totalMovement = leftMovement + rightMovement;

  return {
    detected: totalMovement > 0.05,
    intensity: totalMovement,
    side: leftMovement > rightMovement ? 'left' : 'right'
  };
};

export const calculateCenterOfMass = (landmarks) => {
  let sumX = 0, sumY = 0, count = 0;

  landmarks.forEach(landmark => {
    if (isLandmarkVisible(landmark)) {
      sumX += landmark.x;
      sumY += landmark.y;
      count++;
    }
  });

  return count > 0 ? {
    x: sumX / count,
    y: sumY / count
  } : null;
};
